import React from 'react';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Grid from '@material-ui/core/Grid';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Typography from '@material-ui/core/Typography';
import { MenuItem, Select } from '@material-ui/core';
import { useSetupStyles } from './style';

const COMMUNITY_TYPES = [
  'Town/City',
  'First Nation',
  'School',
  'School District / Board',
  'Sports Teams',
  'Other',
];

interface CommunityStepProps {
  control: any;
  errors: any;
}

export default function CommunityStep({ control, errors }: CommunityStepProps) {
  const classes = useSetupStyles();

  return (
    <div className={classes.stepContent}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body1" className={classes.formLabel}>
            Community Name
          </Typography>
          <Controller
            className={classes.textField}
            variant="outlined"
            name="community.communityName"
            control={control}
            rules={{ required: 'Community Name is required.' }}
            defaultValue=""
            as={
              <OutlinedInput
                placeholder="e.g. My Town"
                className={classes.inputStyle}
                labelWidth={0}
              />
            }
          />
          <ErrorMessage
            as={<Typography color="error" />}
            errors={errors}
            name="community.communityName"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1" className={classes.formLabel}>
            Community Type
          </Typography>
          <Controller
            name="community.communityType"
            control={control}
            rules={{ required: 'Community Type is required.' }}
            defaultValue=""
            render={({ onChange, value }) => (
              <Select
                variant="outlined"
                fullWidth
                displayEmpty
                value={value}
                onChange={onChange}
                className={classes.inputStyle}
                style={{ marginTop: 8 }}
              >
                <MenuItem value="" disabled>
                  Select a type...
                </MenuItem>
                {COMMUNITY_TYPES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
          <ErrorMessage
            as={<Typography color="error" />}
            errors={errors}
            name="community.communityType"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1" className={classes.formLabel}>
            About (Optional)
          </Typography>
          <Controller
            className={classes.textField}
            variant="outlined"
            name="community.about"
            control={control}
            defaultValue=""
            as={
              <OutlinedInput
                placeholder="A short description of your community"
                className={classes.inputStyle}
                labelWidth={0}
                multiline
                rows={3}
              />
            }
          />
        </Grid>
      </Grid>
    </div>
  );
}
